import * as Constants from './constants'
import * as Types from './types'

export const split = (payload: Types.Mapping[]): any => {
  const actions: Types.Mapping[] = payload.filter((mapping) => mapping.sync_type_name === Constants.ACTIONS)
  const subscribers: Types.Mapping[] = payload.filter((mapping) => mapping.sync_type_name === Constants.SUBSCRIBERS)
  const topics: Types.Mapping[] = payload.filter((mapping) => mapping.sync_type_name === Constants.TOPICS)
  return {actions, subscribers, topics}
}



// WEBPACK FOOTER //
// ./src/pages/integration-mappings/utils.ts